import styled from 'styled-components';
import { black, lightGray, middleGray, primary } from 'styles/colorProvider';

export const Container = styled.div`
  width: 100%;
  min-height: 70px;
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${lightGray};
  border-radius: 20px;
  margin-top: 15px;
  font-size: 13px;
  position: relative;
  padding: 10px 0;

  .description {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;

    .iconReport {
      width: 5%;
      margin-left: 2%;

      @media (max-width: 1000px) {
        display: none;
      }
    }

    @media (max-width: 1000px) {
      flex-wrap: wrap;
      width: 100%;
      padding: 10px;
    }
  }

  @media (max-width: 1000px) {
    margin-bottom: 10%;
    height: auto;
  }
`;

export const Div = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  margin-left: 2%;
  width: 22%;

  @media (max-width: 1000px) {
    width: 45%;
    margin-bottom: 10px;
  }
`;

export const ActionDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2%;
  width: 10%;

  @media (max-width: 1000px) {
    width: 100%;
    margin-top: 10px;
  }
`;

export const Title = styled.h3`
  font-size: 14px;
  color: ${(props) => props.color || black};
  font-weight: 500;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${middleGray};
  margin: 0;
`;

export const StatusLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.baixada ? primary : '#E67E22')};
`;
